import { lazy } from "react";

/**
 * Wrapper around React.lazy that reloads the page when a chunk fails to load
 * (e.g. after a deployment replaces hashed assets).
 */
export function lazyWithRetry<T extends React.ComponentType<any>>(factory: () => Promise<{ default: T }>) {
  return lazy(() =>
    factory().catch(() => {
      window.location.reload();
      return new Promise<{ default: T }>(() => {});
    })
  );
}
